/* ══════════════════════════════════════════════════════════════════════
   TeakTouch — V4 fusion runtime  ·  2026-10-05
   ──────────────────────────────────────────────────────────────────────
   One script, replacing the prototype's globals:
     woods.js + opt-data.js (data)  →  assets/v4-data.js
     app.js + opt-app.js (behaviour) →  this file
   Nothing here re-declares a global twice, and nothing here builds chrome
   that Liquid already rendered.

   Prototype defects fixed in this file:
     · tier pills used to drop face/format from the URL  → State.set() merges
     · face/format used to rewrite only the URL          → syncMedia() swaps
       real gallery layers and writes the real [data-gallery] node
     · the matcher had category checkboxes only          → per-category style,
       an explicit "none", a clear-all, quantities and URL round-tripping
     · the mega menu was CSS :hover only                 → aria-expanded,
       Escape closes, focus returns to the trigger
     · the mobile header overflowed at 390px             → assets/v4-shop.css
     · "Add to cart" was href="#"                        → real /cart/add.js
   ══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var TT = window.TT;
  if (!TT) return;

  var SHOP = window.TT_SHOP || { live: {}, snapshot: { items: {} } };
  var SNAP = (SHOP.snapshot && SHOP.snapshot.items) || {};

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  /* ══════════════════════════════════════════════════════════════════
     1 · CATALOG RESOLVER — real variants only
     ══════════════════════════════════════════════════════════════════ */

  function classify(values) {
    var out = { tier: null, format: null, tiles: null };
    (values || []).forEach(function (v) {
      var s = String(v).toLowerCase();
      if (out.tier === null) {
        if (/paper/.test(s)) out.tier = 'paper';
        else if (/collector/.test(s)) out.tier = 'collector';
        else if (/heirloom/.test(s)) out.tier = 'heirloom';
      }
      if (out.format === null) {
        if (/chinese/.test(s) || /\bcn\b/.test(s)) out.format = 'cn';
        else if (/\bus\b/.test(s) || /united states/.test(s) || /american/.test(s)) out.format = 'us';
      }
      var m = /\((\d+)\s*tiles?\)/i.exec(s);
      if (m && out.tiles === null) out.tiles = parseInt(m[1], 10);
    });
    return out;
  }

  /* Real tile counts read from the catalog on 2026-10-05. Used only for the
     specification row, never for price or purchasability. */
  var TILES = {
    'paper|us': 160, 'paper|cn': 144,
    'collector|us': 165, 'collector|cn': 160,
    'heirloom|us': 165, 'heirloom|cn': 160
  };

  var Shop = { byWood: {}, liveHandles: {}, anyLive: false };

  TT.order.forEach(function (wid) {
    var rec = { id: wid, handle: null, url: null, productId: null, images: [], variants: [], live: false };
    var lv = SHOP.live && SHOP.live[wid];
    if (lv && lv.variants && lv.variants.length) {
      rec.live = true;
      Shop.anyLive = true;
      rec.handle = lv.handle; rec.url = lv.url; rec.productId = lv.productId;
      rec.images = lv.images || [];
      Shop.liveHandles[lv.handle] = rec;
      lv.variants.forEach(function (v) {
        var c = classify(v.options);
        rec.variants.push({
          id: v.id, title: v.title, price: v.price, priceFmt: v.priceFmt,
          available: !!v.available, tier: c.tier, format: c.format,
          tiles: c.tiles || TILES[c.tier + '|' + c.format] || null, live: true
        });
      });
    } else if (SNAP[wid]) {
      var sn = SNAP[wid];
      rec.handle = sn.handle; rec.productId = sn.productId;
      Object.keys(sn.variants || {}).forEach(function (key) {
        var parts = key.split('|');
        var sv = sn.variants[key];
        var tc = classify([sv.title]);
        rec.variants.push({
          id: null, title: sv.title, price: sv.price, priceFmt: TT.money(sv.price),
          available: false, tier: parts[0], format: parts[1],
          tiles: tc.tiles || TILES[key] || null, live: false
        });
      });
    }
    Shop.byWood[wid] = rec;
  });

  /* face → variant mapping. Loaded from TT_SHOP.faceMap when it exists; the
     data layer ships it empty, so today NO face is orderable. This is the
     single ingestion point a later face mapping plugs into:
         '<wood>|<tier>|<format>|<face>'  →  '<real variant id>'  (or { id }) */
  Shop.faceMap = (SHOP && SHOP.faceMap) || TT.faceMap || {};

  /* the REAL variant for a selection. Without a face this is the tier's own
     edition variant (display-only contexts). With a face the MAPPED id is
     authoritative: the id must exist among the product's OWN variants AND
     still belong to the chosen tier+edition. A missing mapping, an id that is
     not in this product, or a variant from another tier/edition is REFUSED
     (null). It is never silently downgraded to the tier's default variant —
     that downgrade is exactly what would buy two different faces as one and
     the same old variant. */
  Shop.variant = function (wid, tier, format, face) {
    var rec = Shop.byWood[wid];
    if (!rec) return null;
    var i, base = null;
    for (i = 0; i < rec.variants.length; i++) {
      if (rec.variants[i].tier === tier && rec.variants[i].format === format) { base = rec.variants[i]; break; }
    }
    if (!face) return base;
    var m = Shop.faceMap[wid + '|' + tier + '|' + format + '|' + face];
    var vid = (m && typeof m === 'object') ? m.id : m;
    if (vid === undefined || vid === null || vid === '') return null;
    for (i = 0; i < rec.variants.length; i++) {
      var mv = rec.variants[i];
      if (String(mv.id) === String(vid)) {
        if (mv.tier !== tier || mv.format !== format) return null;
        return mv;
      }
    }
    return null;
  };
  Shop.faceMapped = function (wid, tier, format, face) {
    return !!Shop.faceMap[wid + '|' + tier + '|' + format + '|' + face];
  };
  /* the id the cart must actually add for this selection (null = refuse) */
  Shop.mappedId = function (wid, tier, format, face) {
    var v = Shop.variant(wid, tier, format, face);
    return (v && v.id) ? String(v.id) : null;
  };
  /* the chargeable amount for a chosen face, or null when not orderable */
  Shop.chargeable = function (wid, tier, format, face) {
    var v = Shop.variant(wid, tier, format, face);
    return v ? v.price : null;
  };

  /* DISPLAY price = the approved number (399 / 599 / 799). It is never the
     transaction price. When the live variant disagrees with the approved
     number we say so instead of quietly showing the old figure. */
  Shop.approved = function (tier) {
    var t = TT.tiers[tier];
    return t && typeof t.approvedPrice === 'number' ? t.approvedPrice : null;
  };
  Shop.price = function (wid, tier, format, face) {
    var v = Shop.variant(wid, tier, format, face);
    return v ? v.price : null;
  };
  Shop.priceText = function (wid, tier, format, face) {
    var ap = Shop.approved(tier);
    var head = ap === null ? '—' : '$' + ap;
    var v = Shop.variant(wid, tier, format, face);
    var live = v && v.live ? v.price : null;
    if (live === null) {
      return head + ' <span class="price-flag" data-price-flag="notready">'
        + esc(TT.text.notReady) + '</span>';
    }
    /* 399 / 599 / 799 are CONFIRMED figures (owned price readback), so the box
       set is no longer labelled "Provisional" — that word is kept for the
       accessories, whose prices are still preliminary. A live figure that
       disagrees with the confirmed number is still surfaced as a drift, and
       nothing here may be read as "buyable": the cart re-verifies the live
       price before any charge. */
    if (ap !== null && live !== ap) {
      return head + ' <span class="price-flag" data-price-flag="drift">'
        + esc(TT.text.priceDrift) + '</span>';
    }
    return head;
  };
  /* buyable only when: the variant is real and available AND the chosen face
     has a variant mapping AND the live price equals the approved number. */
  Shop.buyable = function (wid, tier, format, face) {
    /* a face with no mapping, or a mapped id that is not this product's own
       variant, resolves to null and can never be bought */
    var v = Shop.variant(wid, tier, format, face);
    if (!(v && v.live && v.id && v.available)) return false;
    var ap = Shop.approved(tier);
    if (ap !== null && v.price !== ap) return false;
    return true;
  };
  Shop.tiles = function (wid, tier, format, face) {
    var v = Shop.variant(wid, tier, format, face);
    if (v && v.tiles) return v.tiles;
    return TILES[tier + '|' + format] || null;
  };
  /* a part becomes purchasable the moment a live product carries its handle */
  Shop.partProduct = function (pid) {
    return Shop.liveHandles['accessory-' + pid] || null;
  };
  /* the one English line that explains why a buy control is inert */
  Shop.stateText = function (wid, tier, format, face) {
    var v = Shop.variant(wid, tier, format, face);
    if (!v) return face ? TT.text.faceUnmapped : TT.text.unavailable;
    if (!v.live) return TT.text.previewOnly;
    if (!v.available) return TT.text.soldOut;
    var ap = Shop.approved(tier);
    if (ap !== null && v.price !== ap) return TT.text.priceMismatch;
    return '';
  };

  /* ══════════════════════════════════════════════════════════════════
     2 · STATE + ROUTER  — one writer, every dimension preserved
     ══════════════════════════════════════════════════════════════════ */

  var PAGE = document.documentElement.getAttribute('data-v4-page') || '';
  var entity = TT.pageEntity(PAGE);

  var KEYS = ['wood', 'tier', 'face', 'format', 'qty', 'from'];

  /* The studio category is a real URL dimension, but ONLY for the accessory
     studio. A box-set, configurator or wood page must never emit one, so the
     write path asks this once and the answer comes from the server-rendered
     page entity, with the studio host as a DOM fallback. */
  function studioContext() {
    if (PAGE === 'accessory-studio') return true;
    return !!document.querySelector('[data-v4="accessory-studio"]');
  }

  function readFrom() {
    var s = {};
    s.wood = TT.resolveWood();
    s.tier = TT.resolveTier();
    var f = TT.qparam('face');
    s.face = (f === 'recoloured' || f === 'traditional') ? f : 'traditional';
    /* `format` is a RESERVED Shopify parameter: a storefront URL carrying it is
       answered with 404 on reload (format=us/cn → 404, format=json → 200). The
       storefront parameter is therefore `edition`; the internal state key stays
       `format`. The prototype's old ?format=us|cn input is still READ as an
       alias so existing local links keep working, but it is never written back. */
    var fm = TT.qparam('edition') || TT.qparam('format');
    s.format = (fm === 'cn' || fm === 'us') ? fm : 'us';
    var q = parseInt(TT.qparam('qty'), 10);
    s.qty = (q && q > 0 && q < 100) ? q : 1;
    var src = TT.qparam('from');
    s.from = /^(home|shop|byset|menu|studio|direct)$/.test(src) ? src : (entity ? 'menu' : 'direct');
    /* the accessory studio's category is a real state dimension that has to
       survive a refresh, so it is read here and validated against the shipped
       category list. An unknown value is NOT adopted — the studio's explicit
       fallback (the first real category) applies instead, and nothing bogus is
       ever written back to the URL. */
    var ty = TT.qparam('type');
    if (TT.matcherOrder.indexOf(ty) !== -1) s.type = ty;
    return s;
  }

  var State = {
    v: readFrom(),
    listeners: [],
    /* a page entity outranks a stale query param for its own dimension */
    init: function () {
      if (entity) {
        if (entity.kind === 'wood') this.v.wood = entity.value;
        if (entity.kind === 'tier') this.v.tier = entity.value;
      }
      this.applyWood();
    },
    applyWood: function () {
      document.documentElement.setAttribute('data-wood', this.v.wood);
    },
    set: function (patch, push) {
      var next = {};
      KEYS.forEach(function (k) { next[k] = (patch[k] === undefined) ? State.v[k] : patch[k]; });
      /* `type` is the studio category: carried through every state write so a
         reference-wood click can not reset it, and validated against the
         shipped category list so an unknown value simply drops out. */
      var ty = (patch.type === undefined) ? State.v.type : patch.type;
      if (TT.matcherOrder.indexOf(ty) !== -1) next.type = ty;
      /* validate — an invalid input falls back instead of breaking the page */
      if (!TT.collections[next.wood]) next.wood = TT.default;
      if (!TT.tiers[next.tier]) next.tier = 'heirloom';
      if (next.face !== 'traditional' && next.face !== 'recoloured') next.face = 'traditional';
      if (next.format !== 'us' && next.format !== 'cn') next.format = 'us';
      next.qty = Math.max(1, Math.min(99, parseInt(next.qty, 10) || 1));
      this.v = next;
      this.applyWood();
      this.write(push);
      this.emit();
    },
    query: function (patch) {
      /* called as query() from write() with no argument, and as query({...})
         from anywhere that wants to preview a change. Defaulting to the live
         state is required: without it `patch[k]` threw and every pill, qty
         step and accessory change aborted before emit(). */
      patch = patch || State.v;
      var next = {};
      KEYS.forEach(function (k) { next[k] = (patch[k] === undefined) ? State.v[k] : patch[k]; });
      var out = 'wood=' + encodeURIComponent(next.wood) +
        '&tier=' + encodeURIComponent(next.tier) +
        '&face=' + encodeURIComponent(next.face) +
        '&edition=' + encodeURIComponent(next.format) +
        '&qty=' + next.qty +
        '&from=' + encodeURIComponent(next.from);
      /* the studio category rides the URL only on the accessory studio and only
         when it is a real category, so a refresh keeps it and no other page can
         inherit one. */
      var ty = (patch.type === undefined) ? State.v.type : patch.type;
      if (ty && TT.matcherOrder.indexOf(ty) !== -1 && studioContext()) {
        out += '&type=' + encodeURIComponent(ty);
      }
      var acc = Acc.serialize();
      if (acc) out += '&a=' + encodeURIComponent(acc);
      /* a temporary ?view= test mode survives a state write, so a reload or a
         shared link keeps working. A formal page carries no view, so its URLs
         and links are never polluted with one. */
      var view = TT.qparam('view');
      if (view) out += '&view=' + encodeURIComponent(view);
      return '?' + out;
    },
    write: function (push) {
      if (!window.history || !window.history.replaceState) return;
      /* the URL build is inside the guard too: a sandboxed or file:// origin
         must never abort the state change that follows it */
      try {
        var url = window.location.pathname + this.query();
        if (push) window.history.pushState(null, '', url);
        else window.history.replaceState(null, '', url);
      } catch (e) { /* file:// or sandboxed — the UI still updates */ }
    },
    on: function (fn) { this.listeners.push(fn); },
    emit: function () {
      var v = this.v;
      this.listeners.forEach(function (fn) { try { fn(v); } catch (e) {} });
    }
  };

  /* ══════════════════════════════════════════════════════════════════
     3 · ACCESSORY SELECTION  (style · none · clear · qty · serialize)
     ══════════════════════════════════════════════════════════════════ */

  var Acc = {
    pick: {},
    parse: function () {
      var raw = /[?&]a=([^&]+)/.exec(window.location.search || '');
      var self = this;
      self.pick = {};
      if (!raw) return;
      decodeURIComponent(raw[1]).split(',').forEach(function (chunk) {
        var p = chunk.split(':');
        var id = p[0];
        if (!TT.parts[id]) return;
        if (p[1] === 'none') { self.pick[id] = { style: 'none', qty: 0 }; return; }
        self.pick[id] = { style: p[1] || 'matched', qty: Math.max(1, Math.min(9, parseInt(p[2], 10) || 1)) };
      });
    },
    serialize: function () {
      var out = [];
      TT.matcherOrder.forEach(function (id) {
        var s = Acc.pick[id];
        if (!s) return;
        out.push(id + ':' + (s.style === 'none' ? 'none' : s.style) + ':' + s.qty);
      });
      return out.join(',');
    },
    style: function (id) { var s = this.pick[id]; return s ? s.style : null; },
    qty: function (id) { var s = this.pick[id]; return s ? s.qty : 0; },
    isOn: function (id) { var s = this.pick[id]; return !!(s && s.style !== 'none' && s.qty > 0); },
    setStyle: function (id, style) {
      if (style === 'none') { this.pick[id] = { style: 'none', qty: 0 }; }
      else { this.pick[id] = { style: style, qty: this.qty(id) || 1 }; }
      this.commit();
    },
    setQty: function (id, q) {
      var s = this.pick[id];
      if (!s || s.style === 'none') return;
      s.qty = Math.max(1, Math.min(9, q));
      this.commit();
    },
    clear: function (id) { delete this.pick[id]; this.commit(); },
    clearAll: function () { this.pick = {}; this.commit(); },
    commit: function () { State.write(false); renderAccSummary(); State.emit(); },
    /* The buying list. A selected part is ALWAYS retained — including parts
       whose price or SKU is still pending — so a chosen item can never silently
       vanish from the list. Only "not wanted" and a zero quantity are excluded.
       `priced` separates the rows that may be charged from the ones still
       awaiting a quote; the tiles are the reference object and never enter. */
    list: function () {
      var out = [];
      TT.matcherOrder.forEach(function (id) {
        var s = Acc.pick[id];
        if (!s || s.style === 'none' || s.qty < 1) return;
        var p = TT.parts[id];
        out.push({
          id: id, name: p.name, style: s.style, qty: s.qty, price: p.price, unit: p.unit,
          priced: p.price !== null, pricePending: p.price === null,
          skuPending: !!p.skuPending, unitPending: !!p.unitPending
        });
      });
      return out;
    },
    total: function () {
      var t = 0;
      this.list().forEach(function (r) { if (r.price) t += r.price * r.qty; });
      return t;
    },
    pendingCount: function () {
      var n = 0;
      this.list().forEach(function (r) { if (!r.price) n++; });
      return n;
    }
  };
  Acc.parse();

  /* ══════════════════════════════════════════════════════════════════
     4 · CART — the platform's own endpoints, no order submission
     ══════════════════════════════════════════════════════════════════ */

  var Cart = {
    count: 0, busy: false, items: [],
    req: function (path, opts) {
      var o = opts || {};
      o.credentials = 'same-origin';
      o.headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      return fetch(path, o).then(function (res) {
        return res.text().then(function (t) {
          var body = null;
          try { body = JSON.parse(t); } catch (e) { body = null; }
          if (!res.ok) {
            var msg = (body && (body.description || body.message)) || ('HTTP ' + res.status);
            var err = new Error(msg); err.status = res.status; err.body = body; throw err;
          }
          return body;
        });
      });
    },
    add: function (variantId, qty) {
      if (!variantId) return Promise.reject(new Error(TT.text.unavailable));
      if (this.busy) return Promise.resolve(null);
      this.busy = true;
      return this.req('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
      }).then(function (data) {
        Cart.busy = false;
        Cart.refreshCount();
        return data;
      }).catch(function (err) {
        Cart.busy = false;
        throw err;
      });
    },
    change: function (key, qty) {
      return this.req('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (data) { Cart.render(data); return data; });
    },
    load: function () { return this.req('/cart.js', { method: 'GET' }); },
    refreshCount: function () {
      return this.load().then(function (c) { Cart.render(c); }).catch(function () {});
    },
    render: function (c) {
      this.count = (c && c.item_count) || 0;
      this.items = (c && c.items) || [];
      $$('[data-cart-count]').forEach(function (el) { el.textContent = String(Cart.count); });
      var body = $('[data-cart-body]');
      if (body) {
        if (!this.items.length) {
          body.innerHTML = '<p class="cart-empty">' + esc(TT.text.emptyCart) + '</p>';
        } else {
          body.innerHTML = this.items.map(function (it) {
            return '<div class="cart-line">' +
              '<span class="cl-name">' + esc(it.product_title || it.title) +
              ' <small>' + esc(it.variant_title || '') + '</small></span>' +
              '<span class="cl-qty">× ' + it.quantity + '</span>' +
              '<span class="cl-price">' + esc(it.final_line_price ? moneyFromCents(it.final_line_price) : '') + '</span>' +
              '</div>';
          }).join('') +
            '<div class="cart-total"><span>Subtotal</span><span>' + esc(moneyFromCents(c.total_price)) + '</span></div>';
        }
      }
    },
    open: function () {
      var d = $('[data-cart-drawer]');
      if (!d) return;
      d.setAttribute('data-open', 'true');
      d.setAttribute('aria-hidden', 'false');
      var sc = $('[data-scrim]'); if (sc) { sc.hidden = false; sc.setAttribute('data-open', 'true'); }
      this.refreshCount();
      var close = d.querySelector('[data-cart-close]'); if (close) close.focus();
    },
    close: function () {
      var d = $('[data-cart-drawer]');
      if (!d) return;
      d.setAttribute('data-open', 'false');
      d.setAttribute('aria-hidden', 'true');
      var sc = $('[data-scrim]'); if (sc) { sc.hidden = true; sc.setAttribute('data-open', 'false'); }
    },
    isOpen: function () {
      var d = $('[data-cart-drawer]');
      return !!(d && d.getAttribute('data-open') === 'true');
    }
  };
  function moneyFromCents(c) { return '$' + (c / 100).toFixed(2); }

  /* ══════════════════════════════════════════════════════════════════
     5 · CHROME — sticky header, search, drawer, keyboard, mega menu
     ══════════════════════════════════════════════════════════════════ */

  function initChrome() {
    function onScroll() { document.body.classList.toggle('scrolled', window.scrollY > 60); }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* search */
    var sT = $('#search-toggle'), sB = $('#search-bar'), sC = $('#search-close');
    function setSearch(open) {
      if (!sB) return;
      sB.classList.toggle('open', open);
      if (sT) sT.setAttribute('aria-expanded', String(open));
      if (open) { var i = sB.querySelector('input'); if (i) i.focus(); }
    }
    if (sT) sT.addEventListener('click', function () { setSearch(!sB.classList.contains('open')); });
    if (sC) sC.addEventListener('click', function () { setSearch(false); if (sT) sT.focus(); });

    /* mobile drawer */
    var burger = $('#burger'), drawer = $('#drawer'), dClose = $('#drawer-close');
    var lastFocus = null;
    function setDrawer(open) {
      if (!drawer) return;
      if (open) lastFocus = document.activeElement;
      drawer.classList.toggle('open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      if (burger) burger.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
      /* focus never stays behind the overlay */
      if (open) {
        var f = drawer.querySelector('a,button');
        if (f) f.focus();
      } else if (lastFocus && lastFocus.focus) {
        lastFocus.focus();
      }
    }
    if (burger) burger.addEventListener('click', function () { setDrawer(true); });
    if (dClose) dClose.addEventListener('click', function () { setDrawer(false); });
    if (drawer) $$('a', drawer).forEach(function (a) { a.addEventListener('click', function () { setDrawer(false); }); });

    $$('.acc-btn', drawer || document).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.nextElementSibling;
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.classList.toggle('open', !open);
        panel.style.maxHeight = open ? '' : (panel.scrollHeight + 24) + 'px';
      });
    });

    /* mega menu — CSS still gives pointer users the hover reveal, and
       :focus-within keeps the panel up while the trigger holds focus. Both keep
       matching after Escape, so closing only removes .is-open and the theme's
       own rule re-reveals the panel. The runtime therefore also sets
       html.nav-suppress, which outranks theme.css:210, and lifts it the moment
       the pointer or focus actually leaves the item — a fresh hover or
       ArrowDown opens normally. */
    var openItems = [];
    var navSuppress = false;
    function setSuppress(on) {
      navSuppress = !!on;
      document.documentElement.classList.toggle('nav-suppress', !!on);
    }
    function closeMenus(restore, suppress) {
      openItems.forEach(function (item) {
        item.classList.remove('is-open');
        var link = item.querySelector('.nav-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
      if (restore && openItems.length) {
        var l = openItems[openItems.length - 1].querySelector('.nav-link');
        if (l) l.focus();
      }
      openItems = [];
      if (suppress) setSuppress(true);
    }
    $$('.nav-item').forEach(function (item) {
      var link = item.querySelector('.nav-link');
      var panel = item.querySelector('.panel');
      if (!link || !panel) return;
      link.setAttribute('aria-expanded', 'false');
      function open(force) {
        if (navSuppress && !force) return;
        if (force) setSuppress(false);
        closeMenus(false, false);
        item.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
        openItems.push(item);
      }
      function close() {
        item.classList.remove('is-open');
        link.setAttribute('aria-expanded', 'false');
        openItems = openItems.filter(function (i) { return i !== item; });
      }
      item.addEventListener('mouseenter', function () { setSuppress(false); open(false); });
      item.addEventListener('mouseleave', function () { close(); setSuppress(false); });
      item.addEventListener('focusin', function () { open(false); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) { close(); setSuppress(false); }
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          var first = panel.querySelector('a');
          if (first) { e.preventDefault(); open(true); first.focus(); }
        }
      });
    });

    /* one Escape handler for every layer, topmost first */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (Cart.isOpen()) { Cart.close(); return; }
      if (drawer && drawer.classList.contains('open')) { setDrawer(false); return; }
      if (sB && sB.classList.contains('open')) { setSearch(false); if (sT) sT.focus(); return; }
      if (openItems.length) closeMenus(true, true);
    });

    /* cart */
    $$('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (ev) { ev.preventDefault(); Cart.open(); });
    });
    $$('[data-cart-close]').forEach(function (b) {
      b.addEventListener('click', function () { Cart.close(); });
    });
    var scrim = $('[data-scrim]');
    if (scrim) scrim.addEventListener('click', function () {
      Cart.close();
      if (drawer && drawer.classList.contains('open')) setDrawer(false);
    });
    Cart.refreshCount();

    /* reveal */
    var items = $$('.rv');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
      }, { threshold: .1, rootMargin: '0px 0px -36px 0px' });
      items.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(el); });
    }
  }

  /* ══════════════════════════════════════════════════════════════════
     6 · RENDERERS
     ══════════════════════════════════════════════════════════════════ */

  function mediaSlot(wood, kind, ratioClass, label) {
    var rec = Shop.byWood[wood];
    var img = rec && rec.images && rec.images.length ? rec.images[0] : null;
    if (img && img.url) {
      return '<img src="' + esc(img.url) + '" alt="' + esc(img.alt || label) + '" loading="lazy">';
    }
    return '<div class="ph ' + (ratioClass || '') + '"><span>' + esc(label) + '</span></div>';
  }

  /* the (wood,tier,face,edition) album. TT_SHOP.gallery (delivered from Liquid
     / an Admin read) wins over TT.gallery (the shipped config file); neither
     present means an empty list and the caller falls back to the 4:5 frame. */
  function gallerySlots(wood, tier, face, edition) {
    var k = wood + '|' + tier + '|' + face + '|' + edition;
    var lists = [
      (SHOP.gallery && SHOP.gallery[k]) || null,
      (TT.gallery && TT.gallery.slots && TT.gallery.slots[k]) || null
    ];
    for (var i = 0; i < lists.length; i++) {
      if (lists[i] && lists[i].length) {
        return lists[i].filter(function (s) { return s && typeof s === 'object'; });
      }
    }
    return [];
  }

  /* ── home ─────────────────────────────────────────────────────────── */
  function renderHome() {
    /* the club band on the home page has its own stats list */
    renderClub(document);
    /* one media slot per collection panel — never all four into each box */
    $$('[data-home-media]').forEach(function (box) {
      var id = box.getAttribute('data-home-media');
      var c = TT.collections[id];
      if (!c) return;
      box.innerHTML = mediaSlot(id, 'face', '', c.name + ' · ' + c.species + ' · tile face 4:5');
    });
  }

  /* ── shop wood space ──────────────────────────────────────────────── */
  function renderShopWood() {
    var w = State.v.wood;
    var rec = Shop.byWood[w];
    var host = $('[data-v4="shop-wood"]');
    if (!host) return;
    var W = TT.collections[w];

    /* the wood name is the page's own identity — paint it from the entity */
    host.querySelectorAll('[data-pd-name]').forEach(function (el) { el.textContent = W.name; });
    host.querySelectorAll('[data-pd-wood]').forEach(function (el) { el.textContent = W.name + ' · ' + W.species; });
    document.title = W.name + ' — TeakTouch';

    $$('[data-shop-media]').forEach(function (b) {
      b.innerHTML = mediaSlot(w, 'face', '', W.name + ' tile face, full width');
    });

    /* tier prices come from the real catalog, never from the data file */
    $$('[data-tier-price]').forEach(function (el) {
      el.innerHTML = Shop.priceText(w, el.getAttribute('data-tier-price'), State.v.format);
    });
    $$('[data-tier-state]').forEach(function (el) {
      var t = el.getAttribute('data-tier-state');
      var txt = Shop.stateText(w, t, State.v.format);
      el.textContent = txt;
      el.hidden = !txt;
    });

    /* each "Compare this set" opens the by-set page FOR THE WOOD YOU ARE IN
       instead of a hardcoded default. The Page entities are still pending; the
       query is what makes the target correct the moment they exist. */
    host.querySelectorAll('[data-compare-set]').forEach(function (a) {
      var t = a.getAttribute('data-compare-set');
      var route = TT.routes.bySet[t];
      if (route) a.setAttribute('href', route + '?wood=' + encodeURIComponent(w) + '&from=shop');
    });

    var matcher = host.querySelector('[data-matcher]');
    if (matcher) initMatcher(matcher);

    var rail = host.querySelector('[data-rail]');
    if (rail) {
      var list = TT.designs[w] || [];
      /* Every wood really generates its own cards from TT.designs[w]. No back
         office stands behind a design's status, so every card reads "Preview"
         and there is NO want/vote bar: the old progress meter was a fabricated
         tally with nothing behind it. */
      rail.innerHTML = list.map(function (d) {
        return '<article class="dcard">' +
          '<span class="dstat preview">Preview</span>' +
          '<span class="dn">Design ' + esc(d.n) + '</span>' +
          '<h4>' + esc(d.name) + '</h4>' +
          '<p>' + esc(d.blurb) + '</p>' +
          '<div class="dfoot">' + esc(d.tag) + '</div>' +
          '</article>';
      }).join('');
    }

    var other = host.querySelector('[data-other]');
    if (other) {
      other.innerHTML = TT.order.filter(function (id) { return id !== w; }).map(function (id) {
        var c = TT.collections[id];
        return '<a class="ocard" data-w="' + id + '" href="' + TT.routes.shopWood[id] + '?from=shop">' +
          '<span class="otop"></span><span class="owash"></span>' +
          '<span class="obody">' +
          '<span class="ospecies">' + esc(c.species) + '</span>' +
          '<h3>' + esc(c.name) + '</h3>' +
          '<p>' + esc(c.tone) + '</p>' +
          '<span class="octa">Enter ' + esc(c.name) + ' <span>→</span></span>' +
          '</span></a>';
      }).join('');
    }

    renderClub(host);
  }

  function renderClub(scope) {
    var box = (scope || document).querySelector('[data-club]');
    if (!box) return;
    var K = TT.clubHome;
    var target = (scope || document).querySelector('[data-club-stats]');
    if (target) {
      target.innerHTML = K.stats.map(function (s) {
        return '<li><span class="k">' + esc(s.k) + '</span>' +
          '<span class="v">' + esc(s.v) + '<small>' + esc(s.src) + '</small></span></li>';
      }).join('');
    }
  }

  /* ── by set ───────────────────────────────────────────────────────── */
  function renderBySet() {
    var host = $('[data-v4="by-set"]');
    if (!host) return;
    var tier = State.v.tier;
    var T = TT.tiers[tier];

    /* the page is about ONE set, so the set names the page */
    host.querySelectorAll('[data-pd-name]').forEach(function (el) { el.textContent = T.name; });
    host.querySelectorAll('[data-pd-sub]').forEach(function (el) { el.textContent = T.sub; });
    document.title = T.name + ' — TeakTouch';

    var woodsBox = host.querySelector('[data-byset-woods]');
    if (woodsBox) {
      woodsBox.innerHTML = TT.order.map(function (id) {
        var c = TT.collections[id];
        var link = TT.routes.configurator + '?wood=' + id + '&tier=' + tier +
          '&face=traditional&edition=' + State.v.format + '&qty=1&from=byset';
        var state = Shop.stateText(id, tier, State.v.format);
        return '<a class="ocard ocard-buy" data-w="' + id + '" href="' + link + '">' +
          '<span class="otop"></span><span class="owash"></span>' +
          '<span class="obody">' +
          '<span class="ospecies">' + esc(c.species) + ' · ' + esc(c.status) + '</span>' +
          '<h3>' + esc(c.name) + '</h3>' +
          /* priceText emits markup; escaping it would print the flag's tag */
          '<span class="oprice" data-byset-price="' + id + '">' + Shop.priceText(id, tier, State.v.format) + '</span>' +
          '<p>' + esc(T.name) + ' in ' + esc(c.name) + '.</p>' +
          (state ? '<span class="ostate">' + esc(state) + '</span>' : '') +
          '<span class="octa">Open with ' + esc(T.name) + ' preselected <span>→</span></span>' +
          '</span></a>';
      }).join('');
    }

    /* the page's own hero CTA points at the same configurator, preselected */
    $$('[data-byset-cta]').forEach(function (a) {
      a.setAttribute('href', TT.routes.configurator + '?wood=' + State.v.wood + '&tier=' + tier +
        '&face=' + State.v.face + '&edition=' + State.v.format + '&qty=' + State.v.qty + '&from=byset');
    });
  }

  /* ── matcher ──────────────────────────────────────────────────────── */
  function initMatcher(root) {
    /* binding happens once per node; every re-render reuses the stored paint,
       so listeners can never stack up on the same element */
    if (root.__v4paint) { root.__v4paint(); return; }
    var stage = root.querySelector('[data-mstage]');
    var picker = root.querySelector('[data-mpicker]');
    if (!stage || !picker) return;

    /* the stage stacks the reference tiles plus one layer per part. A part
       layer is either a real transparent asset (p.layer → PNG/WebP/JPG, any
       of them, decided by the file itself, not by the name) or the framed
       placeholder that stands in until the shot exists. Stacking order comes
       from p.z, so the layer sequence is data, not DOM accident. */
    function layerHtml(k, cls) {
      var p = TT.parts[k];
      var z = 'z-index:' + (p.z || 0) + ';';
      if (p.layer) {
        return '<div class="layer ' + cls + '" data-layer="' + k + '" style="' + z + '">' +
          '<img class="layer-img" src="' + esc(p.layer) + '" alt="' + esc(p.name) + '" loading="lazy">' +
          '</div>';
      }
      return '<div class="layer ' + cls + '" data-layer="' + k + '" style="' + z + '">' +
        '<div class="ph">' + esc(p.name) + '<br>same-angle layer</div></div>';
    }

    function paintStage() {
      var w = State.v.wood;
      var c = TT.collections[w];
      var til = Shop.byWood[w];
      var shot = til && til.images && til.images.length ? til.images[0] : null;
      stage.innerHTML =
        '<div class="layer layer-tiles" style="z-index:1">' +
        (shot && shot.url
          ? '<img class="layer-img" src="' + esc(shot.url) + '" alt="' + esc(c.name) + '">'
          : '<div class="ph">' + esc(c.name) + ' · full set (reference)</div>') +
        '</div>' +
        '<span class="badge">' + esc(c.name) + ' · ' + esc(c.species) + '</span>' +
        '<span class="badge-lock">Tiles are fixed</span>' +
        TT.matcherOrder.map(function (k) {
          return layerHtml(k, 'layer-part' + (Acc.isOn(k) ? ' on' : ''));
        }).join('');
    }

    function paintPicker() {
      var w = State.v.wood;
      picker.innerHTML = TT.matcherOrder.map(function (k) {
        var p = TT.parts[k];
        var s = Acc.pick[k];
        var on = Acc.isOn(k);
        var none = s && s.style === 'none';
        var classes = 'mrow' + (on ? ' on' : '') + (none ? ' is-none' : '');
        var hasStyles = !!(p.styles && p.styles.length);
        var styles = (p.styles || []).map(function (st) {
          return '<button type="button" class="mstyle' + (s && s.style === st.id ? ' sel' : '') +
            '" data-part="' + esc(k) + '" data-style="' + esc(st.id) + '">' + esc(st.name) + '</button>';
        }).join('');
        var inner = '';
        if (hasStyles) {
          inner = '<span class="mstyles">' + styles + '</span>';
        } else {
          /* no style data yet → say so; the category is still listed, but it
             has nothing selectable and invents no choice */
          inner = '<span class="mstyles"><span class="mnone-note">' + esc(TT.text.stylePending) + '</span></span>';
        }
        if (none) inner = '<span class="mstyles"><span class="mnone-note">Not wanted</span></span>';
        var priceTxt = p.price === null ? TT.text.pricePending : TT.money(p.price);
        return '<div class="' + classes + '" data-row="' + k + '">' +
          '<span class="mtick">✓</span>' +
          '<span class="mname">' + esc(p.name) + '<small>' + esc(p.blurb) + '</small>' + inner + '</span>' +
          '<span class="mprice">' + esc(priceTxt) +
          '<small>' + esc(p.unit) + '</small>' +
          (on ? '<span class="mqty">' +
            '<button type="button" data-part="' + k + '" data-step="-1" aria-label="Fewer">−</button>' +
            '<b>' + Acc.qty(k) + '</b>' +
            '<button type="button" data-part="' + k + '" data-step="1" aria-label="More">+</button>' +
            '</span>' : '') +
          '</span>' +
          '<span class="mactions">' +
          '<button type="button" class="madd" data-part="' + k + '" data-act="add"' + (hasStyles ? '' : ' disabled aria-disabled="true"') + '>' + (on ? 'Selected' : 'Add') + '</button>' +
          '<button type="button" class="mnone" data-part="' + k + '" data-act="none">None</button>' +
          '<button type="button" class="mclear" data-part="' + k + '" data-act="clear">Clear</button>' +
          '</span>' +
          '</div>';
      }).join('');
    }

    function paint() { paintStage(); paintPicker(); renderAccSummary(root); }

    picker.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-part]');
      if (!b) return;
      e.preventDefault();
      var id = b.getAttribute('data-part');
      var act = b.getAttribute('data-act');
      var st = b.getAttribute('data-style');
      var step = b.getAttribute('data-step');
      if (st) { Acc.setStyle(id, st); }
      else if (act === 'none') { Acc.setStyle(id, 'none'); }
      else if (act === 'clear') { Acc.clear(id); }
      else if (act === 'add') {
        var p = TT.parts[id];
        /* a category with no style data has nothing to select. Inventing a
           "standard" style here would drop a phantom chargeable row into the
           buying list — so it refuses instead. */
        if (!(p.styles && p.styles.length)) return;
        var cur = Acc.style(id);
        Acc.setStyle(id, (cur && cur !== 'none') ? cur : p.styles[0].id);
      }
      else if (step) { Acc.setQty(id, Acc.qty(id) + parseInt(step, 10)); }
      else return;
      paint();
    });

    root.__v4paint = paint;
    paint();
  }

  function renderAccSummary(scope) {
    var boxes = $$('[data-sumbar]', scope || document);
    boxes.forEach(function (box) {
      var v = box.querySelector('[data-msum-v]');
      var n = box.querySelector('[data-msum-n]');
      if (v) v.textContent = TT.money(Acc.total());
      if (n) {
        var rows = Acc.list();
        var parts = rows.length ? rows.length + ' selected' : TT.text.nothingSelected;
        if (Acc.pendingCount()) parts += ' · ' + Acc.pendingCount() + ' ' + TT.text.pricePending.toLowerCase();
        n.textContent = parts;
      }
    });
    $$('[data-acc-list]').forEach(function (box) { box.innerHTML = accListHtml(); });
    /* the total only ever sums known prices; when a selected row is still
       unpriced the figure is explicitly partial instead of quietly low */
    $$('[data-acc-total]').forEach(function (el) {
      el.textContent = TT.money(Acc.total()) +
        (Acc.pendingCount() ? ' (' + TT.text.totalPartial + ')' : '');
    });
    $$('[data-acc-actions]').forEach(function (box) {
      var btn = box.querySelector('[data-acc-buy]');
      if (!btn) return;
      var rows = Acc.list();
      var buyableRows = rows.filter(function (r) { return r.price !== null && Shop.partProduct(r.id); });
      var enabled = rows.length > 0 && buyableRows.length === rows.length;
      btn.disabled = !enabled;
      btn.textContent = rows.length ? 'Add ' + rows.length + ' to cart' : 'Nothing selected';
      var note = box.querySelector('[data-acc-note]');
      if (note) {
        var pend = Acc.pendingCount();
        if (!rows.length) note.textContent = TT.text.nothingSelected;
        else if (pend) note.textContent = TT.text.quoteIncomplete;
        else if (!enabled) note.textContent = TT.text.unavailable;
        else note.textContent = '';
      }
    });
  }

  function accListHtml() {
    var rows = Acc.list();
    if (!rows.length) return '<p class="acc-empty">' + esc(TT.text.nothingSelected) + '</p>';
    return rows.map(function (r) {
      var line = r.price === null ? TT.text.pricePending : TT.money(r.price * r.qty);
      return '<div class="acc-row" data-acc-row="' + esc(r.id) + '">' +
        '<span class="ar-name">' + esc(r.name) + '<small>' + esc(r.style) + '</small></span>' +
        '<span class="ar-qty">× ' + r.qty + '</span>' +
        '<span class="ar-price">' + esc(line) + '</span>' +
        '<button type="button" class="ar-x" data-acc-remove="' + esc(r.id) + '" aria-label="Remove">×</button>' +
        '</div>';
    }).join('');
  }

  /* ── reference wood ───────────────────────────────────────────────────
     The shop-wood matcher stays locked to its own collection. The Accessories
     overview and the accessory studio opt in by rendering a [data-refwood]
     host; the buttons carry data-set-wood, so the existing document handler
     moves the whole page — the matcher stage, the selection summary and the
     studio links all read State.v.wood. */
  function refWoodHtml() {
    var w = State.v.wood;
    return '<span class="rw-label">Reference wood</span>' +
      '<span class="rw-opts">' +
      TT.order.map(function (id) {
        var c = TT.collections[id];
        return '<button type="button" class="rw-opt' + (id === w ? ' sel' : '') +
          '" data-set-wood="' + id + '" aria-pressed="' + (id === w) + '">' +
          esc(c.name) + '<small>' + esc(c.status) + '</small></button>';
      }).join('') +
      '</span>';
  }
  function paintRefWood(scope) {
    $$('[data-refwood]', scope || document).forEach(function (h) { h.innerHTML = refWoodHtml(); });
  }

  function renderAccOverview() {
    var host = $('[data-v4="accessories"]');
    if (!host) return;
    $$('[data-acc-link]').forEach(function (a) {
      var id = a.getAttribute('data-acc-link');
      a.setAttribute('href', TT.routes.accessoryStudio + '?type=' + id + '&wood=' + State.v.wood +
        '&edition=' + State.v.format + '&from=direct');
    });
    paintRefWood(host);
  }

  /* which category the studio opens on. The PRESERVED category wins, so a
     reference-wood click — which rewrites the URL — can never reset it. The URL
     and then the hash are consulted only while no choice has been recorded,
     which also picks up a ?type= the platform settled after load. Anything that
     is not a shipped category is ignored, and the explicit fallback is the
     first real category. */
  function resolveStudioType() {
    if (TT.matcherOrder.indexOf(State.v.type) !== -1) return State.v.type;
    var t = TT.qparam('type');
    if (TT.matcherOrder.indexOf(t) !== -1) { State.v.type = t; return t; }
    var h = String(window.location.hash || '').replace(/^#/, '').split('=')[0];
    if (TT.matcherOrder.indexOf(h) !== -1) { State.v.type = h; return h; }
    return TT.matcherOrder[0];
  }

  function renderAccessoryStudio() {
    var host = $('[data-v4="accessory-studio"]');
    if (!host) return;
    /* The studio must never depend on the query string being final at boot:
       the platform can still be normalising the URL when this first runs. So
       resolve in order — ?type=, then #type, then the first category — and let
       a later pass (below) pick up the settled URL. */
    var type = resolveStudioType();
    var p = TT.parts[type];
    /* The category entry only LOCATES its category — it never selects one.
       Entering the studio must not drop a chargeable part into the buying
       list: the list is built from explicit style data only (a picked style,
       a URL `a=` selection, or a click), so an empty list stays empty and no
       category is auto-substituted for another. */
    host.setAttribute('data-type', type);

    /* name the page first — a matcher failure must never leave it unnamed */
    host.querySelectorAll('[data-studio-title]').forEach(function (el) {
      el.textContent = p.name;
    });
    document.title = p.name + ' — TeakTouch';
    renderAccSummary(host);
    paintRefWood(host);
    var matcher = host.querySelector('[data-matcher]');
    if (matcher) initMatcher(matcher);
  }

  function renderSample() {
    var host = $('[data-v4="sample"]');
    if (!host) return;
    var box = host.querySelector('[data-sample-woods]');
    if (box) {
      box.innerHTML = TT.order.map(function (id) {
        var c = TT.collections[id];
        return '<article class="ocard" data-w="' + id + '">' +
          '<span class="otop"></span><span class="owash"></span>' +
          '<span class="obody">' +
          '<span class="ospecies">' + esc(c.species) + '</span>' +
          '<h3>' + esc(c.name) + '</h3>' +
          '<p>' + esc(c.status) + '</p>' +
          '</span></article>';
      }).join('');
    }
    /* the sample box is a real product or an explicit not-open branch */
    var rec = Shop.liveHandles['sample-swatch-box'] || Shop.liveHandles['material-swatch-kit'];
    $$('[data-sample-cta]').forEach(function (btn) {
      if (rec && rec.variants.length) {
        btn.disabled = !rec.variants[0].available;
        btn.textContent = rec.variants[0].available ? TT.text.addToCart : TT.text.soldOut;
      } else {
        btn.disabled = true;
        btn.textContent = TT.text.unavailable;
      }
    });
    var note = host.querySelector('[data-sample-note]');
    if (note) note.textContent = rec ? '' : TT.text.unavailable;
  }

  /* the gallery's active slot survives re-renders, but a change of selection
     resets it to the first slot of the new album */
  var galleryActive = 0;
  var galleryKey = '';

  /* ── configurator ─────────────────────────────────────────────────── */
  function renderConfigurator() {
    var host = $('[data-v4="configurator"]');
    if (!host) return;
    var v = State.v;
    var w = v.wood, tier = v.tier;
    var W = TT.collections[w], T = TT.tiers[tier];

    /* breadcrumb + titles */
    host.querySelectorAll('[data-pd-name]').forEach(function (el) { el.textContent = T.name; });
    host.querySelectorAll('[data-pd-sub]').forEach(function (el) { el.textContent = T.sub; });
    host.querySelectorAll('[data-pd-wood]').forEach(function (el) { el.textContent = W.name + ' · ' + W.species; });
    host.querySelectorAll('[data-pd-crumb]').forEach(function (el) { el.textContent = W.name + ' · ' + T.name; });

    /* price — tier only */
    /* priceText returns markup (the price plus its optional flag), so it is
       inserted as-is — escaping it would print the flag's tag instead. */
    host.querySelectorAll('[data-pd-price]').forEach(function (el) {
      el.innerHTML = '<span class="cur">USD</span>' + Shop.priceText(w, tier, v.format, v.face);
    });
    var stateEl = host.querySelector('[data-pd-state]');
    if (stateEl) {
      var st = Shop.stateText(w, tier, v.format, v.face);
      stateEl.textContent = st;
      stateEl.hidden = !st;
    }
    var vtitle = host.querySelector('[data-pd-variant]');
    if (vtitle) {
      var vv = Shop.variant(w, tier, v.format, v.face);
      vtitle.textContent = vv ? vv.title : '';
    }

    /* spec row goes with the variant, not with the marketing copy */
    var tilesEl = host.querySelector('[data-pd-tiles]');
    if (tilesEl) {
      var n = Shop.tiles(w, tier, v.format, v.face);
      tilesEl.textContent = n ? (n + ' tiles') : '—';
    }
    var faceEl = host.querySelector('[data-pd-face]');
    if (faceEl) {
      var fdef = TT.faces.filter(function (f) { return f.id === v.face; })[0];
      faceEl.textContent = fdef ? fdef.name : '—';
    }

    /* what's in the box */
    var inclEl = host.querySelector('[data-pd-incl]');
    if (inclEl) {
      inclEl.innerHTML = T.incl.map(function (i) {
        return '<li' + (i.on ? '' : ' class="off"') + '>' + esc(i.t) + '</li>';
      }).join('');
    }

    /* tier switch — merges, so face/format/qty survive */
    host.querySelectorAll('[data-tier-switch]').forEach(function (sw) {
      sw.innerHTML = TT.tierOrder.map(function (k) {
        var t = TT.tiers[k];
        return '<button type="button" class="pill pill-btn' + (k === tier ? ' dark' : '') +
          '" data-set-tier="' + k + '" aria-pressed="' + (k === tier) + '">' + esc(t.name) + '</button>';
      }).join('');
    });

    /* the other three axes */
    host.querySelectorAll('[data-ax="wood"]').forEach(function (ax) {
      ax.innerHTML = TT.order.map(function (id) {
        var c = TT.collections[id];
        return '<button type="button" class="pill pill-btn' + (id === w ? ' dark' : '') +
          '" data-set-wood="' + id + '" aria-pressed="' + (id === w) + '">' + esc(c.name) + '</button>';
      }).join('');
    });
    host.querySelectorAll('[data-ax="face"]').forEach(function (ax) {
      ax.innerHTML = TT.faces.map(function (f) {
        return '<button type="button" class="pill pill-btn' + (f.id === v.face ? ' dark' : '') +
          '" data-set-face="' + f.id + '" aria-pressed="' + (f.id === v.face) + '">' + esc(f.name) + '</button>';
      }).join('');
    });
    host.querySelectorAll('[data-ax="format"]').forEach(function (ax) {
      ax.innerHTML = TT.formats.map(function (f) {
        return '<button type="button" class="pill pill-btn' + (f.id === v.format ? ' dark' : '') +
          '" data-set-format="' + f.id + '" aria-pressed="' + (f.id === v.format) + '">' + esc(f.name) + '</button>';
      }).join('');
    });

    /* gallery — a real album for the CURRENT selection. Slots come from the
       (wood,tier,face,edition) registry, so adding media is a data edit and
       not a code change; an empty registry still renders the 4:5 frame. */
    var gkey = w + '|' + tier + '|' + v.face + '|' + v.format;
    if (gkey !== galleryKey) { galleryKey = gkey; galleryActive = 0; }
    var slots = gallerySlots(w, tier, v.face, v.format);
    if (!slots.length) slots = [{ role: 'stage', url: null, alt: W.name + ' · ' + T.name }];
    if (galleryActive >= slots.length || galleryActive < 0) galleryActive = 0;
    var activeSlot = slots[galleryActive] || slots[0];

    var gallery = host.querySelector('[data-gallery]');
    if (gallery) {
      gallery.setAttribute('data-state', w + ' · ' + v.face + ' · ' + v.format);
      gallery.setAttribute('data-slot', String(galleryActive));
      gallery.setAttribute('data-slots', String(slots.length));
      gallery.innerHTML =
        '<div class="g-base" data-p="' + esc(w) + '">' +
        (activeSlot && activeSlot.url
          ? '<img src="' + esc(activeSlot.url) + '" alt="' + esc(activeSlot.alt || (W.name + ' ' + T.name)) + '">'
          : '<div class="ph ph-4x5 ph-dark"><span>' + esc((activeSlot && activeSlot.role ? activeSlot.role + ' · ' : '') + W.name + ' · ' + T.name + ' · 4:5') + '</span></div>') +
        '</div>' +
        '<div class="g-face" data-face="' + esc(v.face) + '">' +
        (v.face === 'recoloured'
          ? '<div class="g-tint" data-p="' + esc(w) + '"></div>'
          : '<div class="g-plain"></div>') +
        '</div>' +
        '<span class="g-badge">' + esc(W.name) + ' · ' + esc(v.format.toUpperCase()) + '</span>';
    }

    /* thumbnails — one control per slot; clicking swaps the main frame by slot
       INDEX, so the picture changes and a label never stands in for it */
    var thumbs = host.querySelector('[data-thumbs]');
    if (thumbs) {
      thumbs.innerHTML = slots.map(function (s, i) {
        return '<button type="button" class="ph pdt" data-gallery-slot="' + i + '"' +
          (i === galleryActive ? ' aria-current="true"' : '') +
          ' aria-label="View ' + (i + 1) + ' of ' + slots.length + '">' +
          (s && s.url
            ? '<img src="' + esc(s.url) + '" alt="' + esc(s.alt || '') + '" loading="lazy">'
            : '<span>' + esc((s && s.role) || 'view') + '</span>') +
          '</button>';
      }).join('');
    }

    /* "Compare the three tiers" belongs to the CURRENT wood: it lands on this
       wood's Shop space at #own, the "Three ways to own it" section where the
       three tiers really sit side by side. The formal Page is still pending;
       the target semantics are already the real ones. */
    var cmp = host.querySelector('[data-compare-tiers]');
    if (cmp && TT.routes.shopWood[w]) cmp.setAttribute('href', TT.routes.shopWood[w] + '#own');

    /* quantity */
    var qEl = host.querySelector('[data-pd-qty]');
    if (qEl) qEl.textContent = String(v.qty);

    /* add to cart — armed only by a real, available variant whose live price
       equals the approved number AND whose face maps to its OWN variant */
    var buyable = Shop.buyable(w, tier, v.format, v.face);
    host.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      /* the button carries the MAPPED variant id for this exact face, so the
         cart adds the face the shopper chose — or nothing at all */
      var vv = Shop.variant(w, tier, v.format, v.face);
      btn.disabled = !buyable;
      btn.setAttribute('data-variant', vv && vv.id ? String(vv.id) : '');
      btn.textContent = buyable ? TT.text.addToCart : TT.text.unavailable;
      btn.setAttribute('aria-disabled', String(!buyable));
    });

    renderClub(host);
  }

  /* ══════════════════════════════════════════════════════════════════
     7 · EVENT WIRING
     ══════════════════════════════════════════════════════════════════ */

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-set-tier],[data-set-wood],[data-set-face],[data-set-format],[data-pd-step],[data-add-to-cart],[data-acc-remove],[data-acc-clear],[data-acc-buy],[data-gallery-slot]') : null;
    if (!el) return;

    /* a thumbnail selects a slot; the main frame is redrawn from that slot */
    if (el.hasAttribute('data-gallery-slot')) {
      e.preventDefault();
      galleryActive = parseInt(el.getAttribute('data-gallery-slot'), 10) || 0;
      renderConfigurator();
      return;
    }
    if (el.hasAttribute('data-set-tier')) { State.set({ tier: el.getAttribute('data-set-tier') }); return; }
    if (el.hasAttribute('data-set-wood')) { State.set({ wood: el.getAttribute('data-set-wood') }); return; }
    if (el.hasAttribute('data-set-face')) { State.set({ face: el.getAttribute('data-set-face') }); return; }
    if (el.hasAttribute('data-set-format')) { State.set({ format: el.getAttribute('data-set-format') }); return; }
    if (el.hasAttribute('data-pd-step')) {
      e.preventDefault();
      var d = parseInt(el.getAttribute('data-pd-step'), 10);
      State.set({ qty: State.v.qty + d });
      return;
    }
    if (el.hasAttribute('data-acc-remove')) { Acc.clear(el.getAttribute('data-acc-remove')); return; }
    if (el.hasAttribute('data-acc-clear')) { Acc.clearAll(); return; }
    if (el.hasAttribute('data-add-to-cart')) {
      e.preventDefault();
      var id = el.getAttribute('data-variant');
      if (!id || el.disabled) return;
      var original = el.textContent;
      el.disabled = true;
      el.textContent = TT.text.adding;
      Cart.add(id, State.v.qty).then(function () {
        el.textContent = TT.text.added;
        setTimeout(function () { el.textContent = original; el.disabled = false; }, 1400);
      }).catch(function (err) {
        el.textContent = original;
        el.disabled = false;
        var errEl = $('[data-cart-error]');
        if (errEl) { errEl.textContent = (err && err.message) || TT.text.cartError; errEl.hidden = false; }
      });
      return;
    }
    if (el.hasAttribute('data-acc-buy')) {
      e.preventDefault();
      var rows = Acc.list();
      var items = rows.filter(function (r) { return Shop.partProduct(r.id); }).map(function (r) {
        var prod = Shop.partProduct(r.id);
        var vv = prod && prod.variants.length ? prod.variants[0] : null;
        return vv ? { id: vv.id, quantity: r.qty } : null;
      }).filter(Boolean);
      if (!items.length) return;
      el.disabled = true;
      Cart.add(items[0].id, items[0].quantity).then(function () {
        el.disabled = false;
      }).catch(function () { el.disabled = false; });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    var el = e.target.closest ? e.target.closest('[data-mrow-toggle]') : null;
    if (el && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); el.click(); }
  });

  /* ══════════════════════════════════════════════════════════════════
     8 · BOOT
     ══════════════════════════════════════════════════════════════════ */

  State.init();
  State.on(function () {
    renderShopWood();
    renderBySet();
    renderConfigurator();
    renderAccessoryStudio();
    renderAccOverview();
    renderAccSummary(document);
  });

  /* One surface failing must never blank the others, and the runtime handle
     must always exist, so each step is isolated and reported. */
  function safe(fn, label) {
    try { fn(); } catch (e) {
      if (window.console && console.error) console.error('[v4] ' + label + ' failed:', e);
    }
  }

  function boot() {
    safe(initChrome, 'chrome');
    safe(renderHome, 'home');
    safe(renderShopWood, 'shop-wood');
    safe(renderBySet, 'by-set');
    safe(renderConfigurator, 'configurator');
    safe(renderAccOverview, 'accessories');
    safe(renderAccessoryStudio, 'accessory-studio');
    safe(renderSample, 'sample');
    safe(function () { renderAccSummary(document); }, 'acc-summary');
  }

  /* expose the handle BEFORE boot so verification never depends on boot */
  window.TT_RUNTIME = { State: State, Shop: Shop, Acc: Acc, Cart: Cart, boot: boot, resolveStudioType: resolveStudioType, studioContext: studioContext };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* once the URL has fully settled, re-resolve the studio's category so a
     ?type= / #type that arrived late is still honoured */
  window.addEventListener('load', function () {
    safe(renderAccessoryStudio, 'accessory-studio (settled)');
  });
})();
